import React, {useEffect, useState} from 'react';
import './App.css';
import {currentLang, loadLgAndCmpSetup, setCurrentLang, setCurrentLangExt} from "./backend/LgSetup";
import {logError} from "./components/model/utils";
import {datadogLogs} from '@datadog/browser-logs'
import {runUnitTests} from "./unittests/AllTestsSuite";
import queryString from "query-string";
import {MainRouter} from "./AppRouter";
import {appdata, load, save} from "./logic_tmp/appdata/AppData";
import {parseParameters} from "./logic/setup/ParametersParser";
import {sendHeight} from "./resizer";
import {initFacebookPixel} from "./logic/funel/FacebookPixelInit";

function App() {
    const [isLoading, setLoading] = useState(true);
    let queryParams = queryString.parse(window.location.search)

    let env
    if (window.location.host.includes("duoclassico.eu"))
        env = "prod"
    else if (window.location.host.includes("localhost"))
        env = "local"
    else
        env = "unknown"
    datadogLogs.init({
        clientToken: 'pub6b1450e4b83c4cf29a3410c71f2a15fd',
        site: 'datadoghq.eu',
        forwardErrorsToLogs: true,
        sessionSampleRate: 100,
        silentMultipleInit: true,
        env: env,
        service: "duopay",
        version: 'V1'
    })

    // Инициализируем Facebook Pixel при загрузке приложения
    useEffect(() => {
        initFacebookPixel();
    }, []);

    useEffect(() => {
        if (queryParams["lng"] !== undefined)
            setCurrentLangExt(queryParams["lng"])
        loadLgAndCmpSetup().then(() => {
            if (window.location.host.includes("local")) {
                appdata.myIp = "93.189.158.30"
                runUnitTests()
            }
            let loadAndSave = (window.location.search === undefined || window.location.search.trim().length < 1 || (!window.location.search.includes("productCode=") && !window.location.search.includes("action=")))
            if (loadAndSave)
                load()
            parseParameters(queryParams, appdata)
            if (!(loadAndSave))
                save()
            setLoading(false);

            window.addEventListener('load', sendHeight("windowLoad"));
            window.addEventListener('resize', sendHeight("windowResized"));

        }).catch((error) => {
            logError(error)
        })
    }, []);
    return (
        <div>
            {isLoading ? <div>Loading.......</div> :
                <MainRouter></MainRouter>
            }
        </div>

    );
}

export default App;
